<template>
    <label class="mc-radio" :class="{
            'is-disabled': disabled
        }">
        <span class="mc-radio__input">
            <span class="mc-radio__inner" :class="{
                'is-checked': !!currentValue,
                'is-disabled': disabled
            }"></span>
            <input type="radio"
                   :name="groupName"
                   :checked="currentValue"
                   @change="change"
                   class="mc-radio__original">
        </span>
        <span class="mc-radio__label" :class="{
            'is-disabled': disabled
        }">
            <slot>{{label}}</slot>
        </span>
    </label>
</template>
<script type="text/ecmascript-6">

    /**
     * 提供配置项 >>
     *
     * value            值绑定             TODO
     * disabled         是否禁用            TODO
     *
     */
    import McContainer from './base-container'
    import { oneOf, findComponentUpward } from '../utils/assist';
    // import Emitter from '../mixins/emitter';

    export default {
        name: 'mc-radio',
        // mixins: [Emitter],
        components: {
            McContainer
        },
        props: {
            name: {
                type: [String, Number],
                default: ''
            },
            value: {
                type: [String, Number, Boolean],
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            trueValue: {
                type: [String, Number, Boolean],
                default: true
            },
            falseValue: {
                type: [String, Number, Boolean],
                default: false
            },
            label: {
                type: [String, Number]
            }
        },
        data: function () {
            return {
                group: false,
                groupName: this.name,
                checked: !!this.value,
                parent:  findComponentUpward(this.$parent, 'mc-radio-group'),
                currentValue: this.value
            }
        },
        methods: {
            change: function (event) {
                if(this.disabled){
                    return false;
                }
                const checked = event.target.checked;
                this.currentValue = checked;
                const value = checked ? this.trueValue : this.falseValue;
                this.$emit('input', value);

                if (this.group) {
                    if (this.label !== undefined) {
                        this.parent && this.parent.change({
                            value: this.label,
                            checked: this.value
                        });
                    }
                } else {
                    this.$emit('change', value);
                }
            },
            updateValue () {
                this.currentValue = this.value === this.trueValue;
            }
        },
        watch: {
            value(val){
                if (val === this.trueValue || val === this.falseValue) {
                    this.updateValue();
                } else {
                    throw 'Value should be trueValue or falseValue.';
                }
            }
        },
        mounted: function () {
            if (this.parent) {
                this.group = true;
                if (this.name && this.name !== this.parent.name) {
                    /* eslint-disable no-console */
                    if (console.warn) {
                        console.warn('[iview] Name does not match Radio Group name.');
                    }
                    /* eslint-enable no-console */
                } else {
                    this.groupName = this.parent.name;
                }
            }

            this.updateValue();
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/base-radio.vue